import React,{useState} from 'react';
import '../../App.css';
import FormSignup from '../FormSignup'

function BiltyCross({ sessionObject, itemNamesDict }) {
  if(!sessionObject.sessionVariables["modules"].includes("cross-bilty")){
    return;
  }
    let crossing = true
    console.log("lklklllllllllllll",crossing)
    return (
      <div className="page-bilty">
        <FormSignup crossingVal={crossing} sessionObject={sessionObject} itemNamesDict={itemNamesDict} />
      </div>
    );
}

export default BiltyCross;